export const loadZendeskWidget = (zendeskKey: string) => {
  const existingScript = document.getElementById('ze-snippet')

  if (!existingScript) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`
    script.id = 'ze-snippet'
    script.onload = function () {
      // @ts-ignore
      zE('webWidget:on', 'chat:status', function (status: string) {
        if (status === 'offline') {
          // @ts-ignore
          zE('webWidget', 'chat:end')
        }
      })
    }
    document.body.appendChild(script)
  }
}
